import { RegisterOptions } from 'react-hook-form';
import {
  moreThancharacterMessage,
  patternErrorMessage,
  required,
} from '../message';

export const createPasswordRegisterOptions = (name: string) =>
  ({
    required: required(name),
    minLength: {
      value: 12,
      message: moreThancharacterMessage(12, 255),
    },
    maxLength: {
      value: 255,
      message: moreThancharacterMessage(12, 255),
    },
    // 「半角英数記号」のチェック
    pattern: {
      // ASCII コード 0x21 から 0x7E までの範囲内
      // @see https://project-fenrir.slack.com/archives/C04SCNQFCAH/p1701485492787109?thread_ts=1701484284.097419&cid=C04SCNQFCAH
      value: /^[\x21-\x7e]*$/,
      message: `${name}は半角文字を入力してください`,
    },
    validate: (value) => {
      if (typeof value === 'string' && !validatePasswordCharacterTypes(value))
        return patternErrorMessage;
      return true;
    },
  }) satisfies RegisterOptions;

/**
 * 英大文字・英小文字・数字・記号のうち、3種類以上あるか
 */
export function validatePasswordCharacterTypes(value: string): boolean {
  const typeCount = [
    /[A-Z]/,
    /[a-z]/,
    /[0-9]/,
    // 記号は ASCII コード 0x21 から 0x7E までの範囲内で英数字でないもの
    // @see https://project-fenrir.slack.com/archives/C04SCNQFCAH/p1701485492787109?thread_ts=1701484284.097419&cid=C04SCNQFCAH
    /(?![A-Za-z0-9])[\x21-\x7e]/,
  ].filter((r) => r.test(value)).length;
  return typeCount >= 3;
}
